import React, { useState } from "react";
import {
  Button,
  Grid,
  Paper,
  styled,
  TextField,
  Typography,
} from "@mui/material";
import Dropdown from "../../reusableComponents/components/generics/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Field, Form } from "react-final-form";
import { getAdminUsers } from "../../action";

const StyledPaper = styled(Paper)(({ theme }) => ({
  ...theme.paper.paper,
}));

const StyledPaperHeader = styled(Grid)(({ theme }) => ({
  ...theme.paper.header,
  fontSize: 600,
  padding: ".8rem",
}));

function AdminFilter() {
  const SignInSuccess = useSelector((state) => state);
  const { t } = useTranslation();
  const [dropValue, setDropValue] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [label, setLabel] = useState("Enter CAMU No.");
  const dispatch = useDispatch();
  let healthData = SignInSuccess?.fosaReducer?.pickerHealthFacilityInsurees[0];

  const handleChange = (event) => {
    const value = event.target.value;
    setDropValue(value);
    getLabel(value);
  };

  const handleSearch = () => {
    let params = buildQueryParams({
      filters: {},
      orderBy: ["-username"],
      first: 10,
      onlyFosaUser: true,
      healthFacility_uuid: healthData?.uuid,
    });
    dispatch(getAdminUsers(params));
  };

  const handleClear = () => {
    setSearchValue("");
    let params = buildQueryParamsClear({
      filters: {},
      orderBy: ["-username"],
      first: 10,
      onlyFosaUser: true,
      healthFacility_uuid: healthData?.uuid,
    });
    dispatch(getAdminUsers(params));
  };

  const buildQueryParamsClear = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (state.first) {
      params.push(`first: ${state.first}`);
    }

    if (state.healthFacility_uuid) {
      params.push(`healthFacilityUuid: "${state.healthFacility_uuid}"`);
    }

    if (state.onlyFosaUser) {
      params.push(`isFosaUser:true`);
    }
    return params;
  };

  const buildQueryParams = (state) => {
    let params = Object.keys(state.filters)
      .filter((f) => !!state.filters[f]["filter"])
      .map((f) => state.filters[f]["filter"]);
    if (searchValue) {
      
      if (dropValue === 1) {
        params.push(`username_Icontains: "${searchValue}"`);
      }

      if (dropValue === 2) {
        params.push(`otherNames: "${searchValue}"`);
      }

      if (dropValue === 3) {
        params.push(`lastName: "${searchValue}"`);
      }

      if (dropValue === 4) {
        params.push(`email: "${searchValue}"`);
      }
    }
    if (state.orderBy) {
      params.push(`orderBy: ["${state.orderBy}"]`);
    }
    if (state.first) {
      params.push(`first: ${state.first}`);
    }

    if (state.healthFacility_uuid) {
      params.push(`healthFacilityUuid: "${state.healthFacility_uuid}"`);
    }

    if (state.onlyFosaUser) {
      params.push(`isFosaUser:true`);
    }
    return params;
  };

  const getLabel = (value) => {
    switch (value) {
      case 1:
        setLabel(t("adminManagement.form.userId"));
        break;
      case 2:
        setLabel(t("adminManagement.form.firstName"));
        break;
      case 3:
        setLabel(t("adminManagement.form.lastName"));
        break;
      case 4:
        setLabel(t("adminManagement.form.email"));
        break;
      default:
        break;
    }
  };

  const searchType = [
    {
      value: 1,
      label: t("adminManagement.form.userId"),
    },
    {
      value: 2,
      label: t("adminManagement.form.firstName"),
    },
    {
      value: 3,
      label: t("adminManagement.form.lastName"),
    },
    {
      value: 4,
      label: t("adminManagement.form.email"),
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <StyledPaper>
          <StyledPaperHeader>
            <Grid item alignItems="center">
              <Typography variant="h6">{t("Search Criteria")}</Typography>
            </Grid>
          </StyledPaperHeader>
          <Form
            autoComplete="off"
            onSubmit={(values) => {
              console.log(values);
            }}
            render={({ handleSubmit, form }) => (
              <form onSubmit={handleSubmit}>
                <Grid
                  style={{
                    display: "flex",
                    marginLeft: ".5rem",
                    marginTop: "1rem",
                    marginBottom: "1rem",
                  }}
                >
                  <Grid item xs={3} className="common-input">
                    <Typography color="#000" fontSize="14">
                      {t("Search Criteria")}
                    </Typography>
                    <Field
                      name="typeOfSearch"
                      component={Dropdown}
                      options={searchType}
                      input={{ value: dropValue, onChange: handleChange }}
                    />
                  </Grid>
                  <Grid item xs={3} className="common-input">
                    {dropValue !== 0 && (
                      <Typography color="#000" fontSize="24">
                        {t(label)}
                      </Typography>
                    )}
                    {dropValue === 1 && (
                      <TextField
                        name="userId"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                        type="text"
                        autoComplete="off"
                      />
                    )}
                    {dropValue === 2 && (
                      <TextField
                        name="firstName"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                        type="text"
                      />
                    )}
                    {dropValue === 3 && (
                      <TextField
                        name="lastName"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                        type="text"
                      />
                    )}
                    {dropValue === 4 && (
                      <TextField
                        name="email"
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                        size="small"
                        type="email"
                      />
                    )}
                  </Grid>
                  {dropValue !== 0 && (
                    <Grid
                      item
                      xs={8}
                      style={{ display: "flex", marginTop: "1.4rem" }}
                    >
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleSearch}
                        >
                          {t("Search")}
                        </Button>
                      </Grid>
                      <Grid item xs={3} className="common-input">
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={handleClear}
                          style={{ marginLeft: "1rem" }}
                        >
                          {t("Clear")}
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </form>
            )}
          />
        </StyledPaper>
      </Grid>
    </Grid>
  );
}

export default AdminFilter;
